const selectDeviceModels = state => state.data.deviceModels

const DeviceModelDataStoreSelectors = {
  deviceModels: selectDeviceModels
}

export default DeviceModelDataStoreSelectors
